import React from 'react';
import DefaultLayout from '../../layouts/default';

// Import the sub-dashboard components from the nested components folder
import EquipmentDashboard from './components/equipmentDashboard';
import EquipmentInventory from './components/equipmentInventory';
import ComplianceAndMaintenance from './components/ComplianceAndMaintenance';
import DashboardBottomGrid from './components/DashboardBottomGrid';
import { EquipmentPageProvider } from './context/EquipmentPageContext';
import EquipmentDetails from './components/EquipmentDetails';
import EquipmentMaintenanceCalendar from './components/EquipmentMaintenanceCalendar';

function EquipmentPage() {
  return (
    <EquipmentPageProvider>
    <DefaultLayout>
      <div className="w-full min-h-screen bg-slate-50/50 space-y-6">
        
        {/* Row 1: Main Metric Overview Statistics Cards Banner */}
        <section>
          <EquipmentDashboard />
        </section>

        {/* Row 2: Secondary Content Split Panel Section */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
          
          {/* Main Left Side Variable Table View Panel (inventory matrix) */}
          <div className="xl:col-span-8 w-full">
            <EquipmentInventory />
          </div>

          {/* Right Side Sticky Sidebar Analytics Column (compliance donut graph & maintenance tracker list) */}
          <div className="xl:col-span-4 w-full">
            <ComplianceAndMaintenance />
          </div>
          
        </div>

        {/* Row 3: Lower Auxiliary Content 4-Column Utility Grid Arrays & Bottom Banners */}
        <section>
          <DashboardBottomGrid />
        </section>

      </div>
      <EquipmentDetails />
      <EquipmentMaintenanceCalendar />
    </DefaultLayout>
    </EquipmentPageProvider>
  );
}

export default EquipmentPage;
